import { connect } from 'react-redux';
import { getFilteredPtoList } from '../../store/openOrder';

import Swimlane from './Swimlane';

const mapStateToProps = state => ({
  fetchPtoListPending: state.pto.openPtos.fetchPtoListPending,
  filteredPtoList: getFilteredPtoList(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Swimlane);
